module.exports = "/_next/static/images/8e00f47f5ebcc73bdacb64984649fefe-man-holding-device-2@1x.jpg";